/**
 * Normalizes the API URL by removing trailing slashes to prevent double slashes in URLs
 * @returns Normalized API URL without trailing slash
 */
export const getNormalizedApiUrl = (): string => {
  const apiUrl = import.meta.env.VITE_API_URL || '';
  return apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
};

/**
 * Joins a base URL and path ensuring there's exactly one slash between them
 * @param baseUrl - The base URL
 * @param path - The path to append
 * @returns Combined URL with proper slash handling
 */
export const joinUrlPaths = (baseUrl: string, path: string): string => {
  const normalizedBase = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
  return `${normalizedBase}/${normalizedPath}`;
}; 